import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { StoreService, StoreTypeService } from 'src/generated_client';

@Component({
  selector: 'app-add-shop-type',
  templateUrl: './add-shop-type.component.html',
  styleUrls: ['./add-shop-type.component.css']
})

export class AddShopTypeComponent implements OnInit {
  id: any;
  isEdit: boolean = false;
  title: string = "";
  nameFormat = "^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1])[a-zA-ZÀ-ÿ\u00f1\u00d1]+$";
  disabled: boolean = false;

  options = [
    { value: true, viewValue: 'Activa' },
    { value: false, viewValue: 'Desactivada' },
  ];

  addShopTypeForm: FormGroup = this.fb.group({
    CdStoreType: [],
    DsName: ['', Validators.compose([Validators.pattern(this.nameFormat), Validators.required])],
    DsDescription: ['', Validators.compose([Validators.pattern(this.nameFormat), Validators.required])],
    IsEnabled: ['', Validators.required],
    DsNewImage: [''],
    ItemImage: ['', Validators.required],
  })


  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public storeTypeService: StoreTypeService,
    private router: Router,
    private snackBar: SnackBarService,
    public storeService: StoreService,
  ) { }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get("id")
    if (this.id != null) {
      this.isEdit = true;
      this.addShopTypeForm.controls['ItemImage'].clearValidators();
      this.storeTypeService.apiStoreTypeGetByIdGet(this.id).subscribe(s => {
        this.addShopTypeForm.controls['CdStoreType'].setValue(Number(this.id));
        this.addShopTypeForm.controls['DsName'].setValue(s.dsName);
        this.addShopTypeForm.controls['DsDescription'].setValue(s.dsDescription);
        this.addShopTypeForm.controls['IsEnabled'].setValue(s.isEnabled);
        this.addShopTypeForm.controls['DsNewImage'].setValue(s.dsImage);
        
        if (s.isEnabled) {
          this.storeService.apiStoreGetAllStoresGet().subscribe(x => {
            let result = x.some(store => store.dsStoreTypeName == s.dsName && store.isEnabled)
            if (result) {
              this.addShopTypeForm.controls['IsEnabled'].disable();
            }
          });
        }
      });
    }
    this.changeTitle();
  }

  changeTitle() {
    if (this.isEdit) {
      this.title = "EDITAR TIPO DE COMERCIO";
    } else {
      this.title = "AGREGAR NUEVO TIPO DE COMERCIO";
    }
  }

  saveChanges(form: any) {

    var file;

    if (form.ItemImage)
      file = form.ItemImage._files[0];

    if (form.IsEnabled == undefined)
      form.IsEnabled = true;

    if (this.isEdit) {
      this.storeTypeService.apiStoreTypePutPutForm(form.CdStoreType, form.DsName, form.DsDescription, form.IsEnabled, undefined, file).subscribe(response => {
        this.router.navigate(['shop-type-management']);
        this.snackBar.openSnackBar('Los cambios se guardados correctamente', 'Aceptar')
      }, (err) => {
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
      });
    } else {
      this.storeTypeService.apiStoreTypePostPostForm(form.DsName, form.DsDescription, form.IsEnabled, undefined, file).subscribe(response => {
        this.router.navigate(['shop-type-management']);
        this.snackBar.openSnackBar('Los cambios se guardados correctamente', 'Aceptar')
      },
        (err) => {
          this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
        });
    }
  }
}
